"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FavoriteSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6,10.5 L3.16993185,7.70687487 C2.91470668,7.43092957 2.936274,6.94857633 3.44967652,6.85614193 L7.3,6.3 L9.29344098,2.46171449 C9.45898437,2.16487122 9.79362488,2.32849121 9.83200387,2.47413822 L11.6,6.3 L15.5369847,6.85593941 C16.0733185,6.9637146 16.0733185,7.46911621 15.8181458,7.70687487 L13,10.5 L13.988746,14.5680344 C14.0648346,14.9502027 13.6356201,15.0785065 13.4701313,14.9577636 L9.50001104,13 L5.53300553,14.9502027 C5.28971181,15.0961295 4.91541886,14.8796145 5,14.5482788 L6,10.5 Z M9.52301242,4.18933556 L7.95090532,7.21636069 L4.58860224,7.7020128 L7.10719438,10.1877279 L6.97081972,10.7398105 L6.29834493,13.4596522 L9.5006923,11.8853598 L9.94228462,12.1031198 L12.6898775,13.4581715 L11.8948947,10.1873441 L12.2960532,9.78974729 L14.3992716,7.70520443 L10.9207645,7.21400638 L9.52301242,4.18933556 Z" })));
};
FavoriteSmall.displayName = 'FavoriteSmall';
exports.default = FavoriteSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FavoriteSmall.js.map